module.exports = __webpack_public_path__ + "media/images/dashboard/cloud-fd34d784fba6a2cbe7dad6a3e01e4723.svg";